import type { useStressAssessmentUserResult } from '../../hooks';
import type { StressAssessmentUserResultPresentation } from '../../presentations';

type UseStressAssessmentUserDataReturn = ReturnType<typeof useStressAssessmentUserResult>;

type Args = {
  result: UseStressAssessmentUserDataReturn['result'];
  answers: UseStressAssessmentUserDataReturn['answers'];
  categories: UseStressAssessmentUserDataReturn['categories'];
};

type PresentationProps = React.ComponentProps<typeof StressAssessmentUserResultPresentation>;

type IConvertToPresentationProps = (
  args: Args
) => Omit<
  PresentationProps,
  'selectedTab' | 'onTabChange' | 'breadcrumbItems' | 'stressAssessmentId'
>;

export const convertToPresentationProps: IConvertToPresentationProps = ({
  result,
  answers,
  categories,
}) => {
  const resultData = result.stress_assessment_result;
  const answersData = answers.stress_assessment_answers;
  const categoriesData = categories.stress_assessment_categories;

  return {
    userName: resultData.full_name,
    result: resultData,
    answers: answersData,
    categories: categoriesData,
  };
};
